import React, {useEffect, useState} from 'react'
import cs from 'classnames'
import Button from '@components/button'
import {Checkbox, message} from 'antd'
import {ArrowLeftOutlined} from '@ant-design/icons'
import {batchUpdateMedialWallShowStatus} from '@apis'

export default function AddProgram({
  visible = false,
  switchVisible = () => {},
  pgList = []
}) {
  const [pgListData, setPgListData] = useState([])

  function updateCheckedStatus(index, checked) {
    const newPgListData = pgListData.slice(0)
    newPgListData[index].dataBigscreenDisplay = checked ? 1 : 0
    setPgListData(newPgListData)
  }

  // 修改节目勾选
  async function updatePg() {
    const addBigScreenPlaySetIdList = pgListData.filter(item => item.dataBigscreenDisplay === 1).map(item => item.id)
    const delScreenPlaySetIdList = pgListData.filter(item => item.dataBigscreenDisplay !== 1).map(item => item.id)
    const params = {
      brokerId: pgListData[0].brokerId,
      addBigScreenPlaySetIdList,
      delScreenPlaySetIdList
    }
    const res = await batchUpdateMedialWallShowStatus(params)
    if (res) {
      message.success('操作成功')
      switchVisible(false)
    }
    console.log('res--', res)
  }

  useEffect(() => {
    if (visible) {
      setPgListData(JSON.parse(JSON.stringify(pgList)))
    }
  }, [visible])

  console.log('pgListData--', pgListData)
  return (
    <div className={
      cs({
        "add-program": true,
        hidden: !visible,
      })
    }>
      <div
        className="back-bar"
        onClick={() => {
          switchVisible(false)
        }}
      >
        <ArrowLeftOutlined />
        <span className="back-sp">
          返回节目列表
        </span>
      </div>
      <div className="program-form-box">
        <div className="pg-list">
          {
            pgListData.map((item, index) => (
              <div
                className="pg-item"
                onClick={() => {
                  updateCheckedStatus(index, item.dataBigscreenDisplay !== 1)
                }}
              >
                <Checkbox
                  checked={item.dataBigscreenDisplay === 1}
                />
                <span className="pg-sp">
                  {index + 1} {item.name}
                </span>
              </div>
            ))
          }
        </div>
        <div className="add-btn-box">
          <Button
            className="add-pg-btn"
            onClick={() => {
              updatePg()
            }}
          >
            确定
          </Button>
        </div>
      </div>
    </div>
  )
}